import * as React from 'react';
import isNil from 'lodash/isNil';

import { withModal } from 'components/modal/ModalHOC';

import FacebookButtonModal from '../FacebookButtonModal';

import {
  handleSetModalStorage
} from 'components/external-integration/facebook/button/utils/facebook-button';

import './facebook-button-modal-handler.scss';

import type { FacebookButtonState } from '../../../types';

interface Props {
  creatorProfileId: number,
  buttonState: FacebookButtonState
}

const arePropsEqual = (
  prevProps: Props,
  nextProps: Props
): boolean => (
  prevProps.buttonState.modalType === nextProps.buttonState.modalType
  && prevProps.buttonState.isFBLoginActive === nextProps.buttonState.isFBLoginActive
  && prevProps.buttonState.isFBLoginExpired === nextProps.buttonState.isFBLoginExpired
);

const FacebookButtonModalHandler: React.FC<Props> = ({
  creatorProfileId,
  buttonState
}: Props) => {
  if (isNil(buttonState.modalType)) {
    return null;
  }

  const DivWithModal = withModal(<div />, {
    modalContent: FacebookButtonModal,
    autoOpenModal: true,
    containerClass: 'facebook-button-modal-handler__container',
    onModalClosed: () => handleSetModalStorage(creatorProfileId, true)
  });

  return (
    <div className="facebook-button-handler">
      <DivWithModal
        key="facebook-button-modal-handler"
        modalContentProps={{
          type: buttonState.modalType
        }}
      />
    </div>
  );
};

export default React.memo(FacebookButtonModalHandler, arePropsEqual);
